<template>
  <div class="watchmap"><div id="watchmap" class="map"></div></div>
</template>
<script>
export default {
  data () {
    return {
      showMark:true,
      deviceId:this.$route.query.id,
      postionMap:{lng:0,lat:0},//点击获取经纬度
      showMarkInfo:{gpsString:'',location:'',locationTime:'',lbsType:''},//显示的mark的老人信息
      center: {lng: 0, lat: 0 },//中心点
      gpsString:'',
      location:'',
      locationTime:'',
      lbsType:'',
      zoom: 3,//缩放比例
      mapType:"",//地图类型，不填就是默认样式
      //设置自定义主题
      mapStyle: {
        styleJson: [
          {
            "featureType": "all",
            "elementType": "geometry",
            "stylers": {
                "hue": "#007fff",
                "saturation": 89
            }
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": {
                "color": "#ffffff"
            }
          }
        ]
      }
    }
  },
  methods: {
    handler () {
      this.center.lng = 114.31667
      this.center.lat = 30.51667
      this.zoom = 12
    },

    //获取老人定位信息
    getRealLocation(){
      let deviceId=this.deviceId
      console.log(deviceId)
      this.$postForm('dmc/watch/queryRealLocationByDeviceId/'+deviceId).then(res => {
        console.log(res) 
        if(res.result != null){
          console.log(res.result.bdGps.split(','))
          this.center.lng=res.result.bdGps.split(',')[1];
          this.center.lat=res.result.bdGps.split(',')[0];
          this.gpsString=res.result.gpsString;
          this.location=res.result.location;
          this.locationTime=res.result.locationTime;
          if(res.result.lbsType==1){
            this.lbsType='gps'
          }else if(res.result.lbsType==2){
            this.lbsType='lbs'
          }else{
             this.lbsType='wifi'
          }
          console.log(this.center);
          this.getPoint();
        }else{
          this.$message({
            message:'暂无孝心手环的定位信息',
            type:'warning'
          })
        }
      })    
    },

      getPoint(){ //获取地图信息，
            this.show = true;
            this.postionMap.lng = this.center.lng;     //获取经度
            this.postionMap.lat = this.center.lat;     //获取纬度
            this.showMarkInfo.gpsString=this.gpsString;
            this.showMarkInfo.location=this.location;
            this.showMarkInfo.locationTime=this.locationTime;
            this.showMarkInfo.lbsType=this.lbsType;
            this.zoom =12;
            const point = new BMapGL.Point(this.center.lng, this.center.lat)
            var map = new BMapGL.Map("watchmap", { minZoom: 5, maxZoom: 21 }); // 创建Map实例,设置地图允许的最小/大级别
            map.centerAndZoom(point, 19); // 初始化地图,设置中心点坐标和地图级别
            //添加地图类型控件
            map.addControl(
              new BMapGL.MapTypeControl({
                mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
              })
            );  
            map.addOverlay(new BMapGL.Marker(point,{
              title:this.gpsString
            }));
            // 2. 通过方法方式设置地图允许的最大最小级别
            // map.setMinZoom(5);
            // map.setMaxZoom(21);
            // map.setCurrentCity("武汉");
            map.enableScrollWheelZoom(true);
            // 创建城市选择控件
            var cityControl = new BMapGL.CityListControl({
              // 控件的停靠位置（可选，默认左上角）
              anchor: BMAP_ANCHOR_TOP_LEFT,
              // 控件基于停靠位置的偏移量（可选）
              offset: new BMapGL.Size(10, 5)
            });
            // 将控件添加到地图上
            map.addControl(cityControl);
            var navi3DCtrl = new BMapGL.NavigationControl3D(); // 添加3D控件
            map.addControl(navi3DCtrl);
            var scaleCtrl = new BMapGL.ScaleControl(); // 添加比例尺控件
            map.addControl(scaleCtrl);
            var zoomCtrl = new BMapGL.ZoomControl(); // 添加比例尺控件
            map.addControl(zoomCtrl);
      },
      handleInfoWindowOpen(){
        if(this.showMark==false){
          this.showMark=true;
        }else{
          this.showMark=false;
        }
      },
      infoWindowClose (e) {
        this.showMark = false
      },
      infoWindowOpen (e) {
        this.showMark = true
      },
  },
 created(){
    this.getRealLocation();
   
  },
  mounted(){
    
  },
}
</script>
<style lang="scss" scoped>
  .watchmap{
        margin:20px 5px;
        border:1px solid rgb(228, 222, 222);
      .map {
        width: 100%;
        height: 600px;
      }
  }
 .citylist_popup_main{
    margin-left:45px;
  }

</style>

